import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    container: {
        borderRadius: '10px',
        boxShadow: 'none',
        display: 'flex',
    },
}));
